import React, { FC, useContext } from "react";
import { Link, LinkProps } from "react-router-dom";
import { AppContext } from "../../app/store";
import { useTranslate } from "../../helpers";
import { alertMessageConditionTopicMap } from "./constants";
import messages from "../../translations/en-US.json";
import { AlertMessageConditions } from "../../app/contexts/AlertMessaging/types";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

export interface AlertMessageLinkProps extends LinkProps {
  condition: AlertMessageConditions;
  textKey: string;
  treatAsButton?: boolean;
}

export const AlertMessageLink: FC<AlertMessageLinkProps> = ({
  onClick,
  condition,
  textKey,
  to,
  treatAsButton = false,
  children,
  ...props
}) => {
  const { dispatch } = useContext(AppContext);
  const t = useTranslate();
  const mct_alert_topic = alertMessageConditionTopicMap[condition];
  const defaultTranslation = messages[textKey];
  const onClickHandler = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    // Analytics
    let pathname;
    if (typeof to === "object") {
      pathname = to.pathname;
    }
    if (treatAsButton) {
      dispatch({
        type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
        settings: {
          button: {
            text: defaultTranslation,
            buttonStyle: AnalyticsButtonStyle.PRIMARY,
            buttonType: AnalyticsButtonType.BUTTON,
          },
          linkUrl: pathname || "",
          custom: { mct_alert_topic },
        },
      });
    } else {
      dispatch({
        type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
        settings: {
          linkText: defaultTranslation,
          linkUrl: pathname || "",
          custom: { mct_alert_topic },
        },
      });
    }
    if (onClick) onClick(event);
  };
  return (
    <Link onClick={onClickHandler} to={to} {...props}>
      {children || t(textKey)}
    </Link>
  );
};
